import { FunctionComponent as F, useState } from "react";
import Stack from "@mui/material/Stack";
import { Box, Grid } from "@mui/material";
import { useAppDispatch } from "../../../core/store/hooks";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '../../UI/Button/Button';
import { useSelector } from "react-redux";
import { IState } from "../../../core/store/store";
import Folder, { Asset } from "./Folder";
import {
  updateFolderParentAsync,
  updateProtocolFolderAsync } from "../../../core/store/protocol/protocolFolder.thunks";



interface IProps
{
  folderId?: number,
  protocolId?: number,
  close: () => void,
  open: boolean
}

const MoveToFolderDialog: F<IProps> = (props: IProps) =>
{
  const appDispatch = useAppDispatch();
  const folder = useSelector((state: IState) =>
    state.protocol.folders.find(f => f.folderId === props.folderId));
  const protocol = useSelector((state: IState) =>
    state.protocol.protocols.find(p => p.protocolId === props.protocolId));

  const name = String(folder?.name || protocol?.name);

  const [folderId, setFolderId] = useState<number | undefined>(undefined);

  const handleDone = async() =>
  {
    if(props.folderId)
      appDispatch(updateFolderParentAsync(props.folderId, folderId));

    if(props.protocolId)
      appDispatch(updateProtocolFolderAsync(props.protocolId, folderId));

    props.close();
  }

  const handleCancel = async() =>
  {
    props.close();
  }

  const handleFolderClick = (folderId?: number) =>
  {
    setFolderId(folderId);
  }

  return (
    <Dialog
      PaperProps={{ sx: { p: '15px', textAlign: 'center' }}}
      open={props.open}
      onClose={handleCancel}>
      <DialogTitle sx={{ fontSize: '30px' }}>{"Move '" + name + "' to..."}</DialogTitle>
      <DialogContent>

        <Stack spacing={2}>

          <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
            <Folder
              asset={protocol || folder as Asset}
              folderId={0}
              selectedFolderId={folderId}
              selectFolder={handleFolderClick}/>
          </Box>

          <Grid container direction='row' key={2}>
            <Grid item xs style={{ display: "flex", justifyContent: "center" }}>
              <Button
                disabled={folderId === undefined}
                label='Ok'
                onClick={handleDone}/>
              <Button
                label='Cancel'
                onClick={handleCancel}/>
            </Grid>
          </Grid>

        </Stack>
      </DialogContent>
    </Dialog>);
}

export default MoveToFolderDialog;

